<form [formGroup]="addStudentForm" class="sb-drawer-content">

        <lib-section-header>
            <ng-container title i18n="@@SUFDesignBlockStudentInfoTitle">Student Info</ng-container>
        </lib-section-header>

        @if (data.AllowedStudentTypes === StudentTypes.ChildOrAdult) {
                <lib-segmented-button
                    [formControl]="addStudentForm.controls.StudentType"
                    (change)="StudentTypeChanged($event)">
                    <ng-container label i18n="@@SUFAllowedStudentTypesLabel">
                        #Student# Type
                    </ng-container>
                    <lib-segmented-button-item
                        [value]="StudentSignupType.AdultStudent">
                            <p class="input-typography" i18n="@@SUFAddStudentAdultRadioOption">Adult</p>
                    </lib-segmented-button-item>
                    <lib-segmented-button-item
                        [value]="StudentSignupType.ChildStudent">
                            <p class="input-typography" i18n="@@SUFAddStudentChildRadioOption">Child</p>
                    </lib-segmented-button-item>
                </lib-segmented-button>
        }

        <!-- DEFAULT -->

        <lib-input-text
            [formControl]="addStudentForm.controls.FirstName"
            [errorMessages]="firstNameError">
            <ng-container label i18n="@@SUFDesignBlockFirstName">
                First Name
            </ng-container>
        </lib-input-text>

        <lib-input-text
            [formControl]="addStudentForm.controls.LastName"
            [errorMessages]="lastNameError">
            <ng-container label i18n="@@SUFDesignBlockLastNayyme">
                Last Name
            </ng-container>
        </lib-input-text>

        @if (data.AdditionalFields?.Gender !== FieldMode.NotPresent) {
            <lib-input-text
                [formControl]="addStudentForm.controls.Gender"
                [layout]="FormFieldLayout.ExclusiveHalf">
                <ng-container label i18n="@@SUFDesignBlockGender">
                    Gender
                </ng-container>
            </lib-input-text>
        }

        @if (data.AdditionalFields?.Birthday !== FieldMode.NotPresent) {

            <lib-input-date
                [formControl]="addStudentForm.controls.Birthday"
                placeholderText="Enter a date..."
                i18n-placeholderText="@@CommonEnterDatePlaceholder"
                [maxDate]="todaysDate"
                [minDate]="specialMinimalDate"
                [scrollLock]="false"
                [layout]="FormFieldLayout.ExclusiveHalf"
                >
                <ng-container label i18n="@@SUFSignupBlcokStep1LabelBirthday">
                    Birthday
                </ng-container>
            </lib-input-date>
        }

        @if (addStudentForm.controls.StudentType.value == StudentSignupType.AdultStudent || data.AdditionalFields?.ChildEmail !== FieldMode.NotPresent) {
            <lib-input-text
                [formControl]="addStudentForm.controls.Email"
                [errorMessages]="emailError">
                <ng-container label i18n="@@SUFDesignBlockEmail">
                    Email
                </ng-container>
            </lib-input-text>
        }

        @if (addStudentForm.controls.StudentType.value == StudentSignupType.AdultStudent || data.AdditionalFields?.ChildPhone !== FieldMode.NotPresent) {
            <lib-input-text
                [formControl]="addStudentForm.controls.Telephone"
                [errorMessages]="phoneError"
                inputFilter="[0-9-\(\)\+]"
                [layout]="FormFieldLayout.ExclusiveHalf">
                <ng-container label i18n="@@SUFDesignBlockMobilePhone">
                    Phone
                </ng-container>
            </lib-input-text>
        }

        <!-- ADDITIONAL FIELDS -->

        <!-- To clarify placeholderText attribute
                if isOptional=true placeholderText is converted to a mat-option so if you leave it empty it will push an empty spot,
                if required placeholderText is not shown so we manually add an No Preferred Subject lib-input-select-item option
                Desired behaviour is we have No Preferred Subject option for both Required and Optional to user won't be locked in -->
        @if (((!isBookingWidget || existingEvents) && data.AdditionalFields?.SubjectTag !== FieldMode.NotPresent)) {
            <lib-input-select
                [formControl]="addStudentForm.controls.SubjectTag"
                [placeholderText]="NO_PREFERRED_SUBJECT"
                (change)="SubjectTagChanged($event)">
                <ng-container label i18n="@@SUFSignupBlcokStep1LabelSubject">
                    #Subject#
                </ng-container>
                @if (addStudentForm.controls.SubjectTag.isRequired) {
                <lib-input-select-item
                    value="">
                    {{ NO_PREFERRED_SUBJECT }}
                </lib-input-select-item>
                }
                <ng-container *ngFor="let subjectTag of preferredSubjectTags">
                    <lib-input-select-item
                        [value]="subjectTag">
                        {{ subjectTag.Name }}
                    </lib-input-select-item>
                </ng-container>
            </lib-input-select>
        }

        @if (data.AdditionalFields?.PreferredTeacher !== FieldMode.NotPresent && teachers.length && !isBookingWidget) {
            <lib-input-select
                [formControl]="addStudentForm.controls.PreferredTeacherID"
                [sortBy]="keepOrder"
                [placeholderText]="NO_PREFERRED_TEACHER"
                (change)="PreferredTeacherChanged($event)">
                <ng-container label i18n="@@SUFDesignBlockPreferredTeacher">
                    Preferred #Teacher#
                </ng-container>
                @if (addStudentForm.controls.PreferredTeacherID.isRequired) {
                    <lib-input-select-item
                        value="">
                        {{ NO_PREFERRED_TEACHER }}
                    </lib-input-select-item>
                }
                <ng-container *ngFor="let teacher of preferredTeachers">
                    <lib-input-select-item
                        [value]="teacher.ID!">
                        {{teacher.Name}}
                    </lib-input-select-item>
                </ng-container>
            </lib-input-select>
        }

        @if (data.AdditionalFields?.SkillLevel !== FieldMode.NotPresent) {
            <lib-input-text
                [formControl]="addStudentForm.controls.SkillLevel">
                <ng-container label i18n="@@SUFDesignBlockSkillLevel">
                    Skill Level
                </ng-container>
            </lib-input-text>
        }

        @if (data.AdditionalFields?.LocalSchool !== FieldMode.NotPresent) {
            <lib-input-text [formControl]="addStudentForm.controls.LocalSchool" >
                <ng-container label i18n="@@SUFSignupBlcokStep1LabelLocalSchool">
                    Current School
                </ng-container>
            </lib-input-text>
        }

        @if (data.AdditionalFields?.FaceTimeID !== FieldMode.NotPresent) {
            <lib-input-text [formControl]="addStudentForm.controls.FaceTimeID" >
                <ng-container label i18n="@@SUFDesignBlockFaceTimeID">
                    FaceTime ID
                </ng-container>
            </lib-input-text>
        }

        <!-- Once per student fields -->
        @if (hasStudentCustomFields) {
            <div class="sb-form-field-full">
                <lib-signup-form-custom-fields #studentCustomFields
                    [kind]="FormAffinity.Student"
                    [fields]="data.CustomFields"
                    [isAdditionalStudent]="signupStudentMode == SignupStudentMode.AdditionalStudent"
                    [form]="addStudentForm"
                    [isViewOnly]="isViewOnly">
                </lib-signup-form-custom-fields>
            </div>
        }


        <!-- Parent Form -->
        @if (addStudentForm.controls.StudentType.value === StudentSignupType.ChildStudent && signupStudentMode !== SignupStudentMode.AdditionalStudent) {

            <lib-section-header [showDivider]="true">
                <ng-container title i18n="@@SUFDesignBlockParentInfoSubtitle">Parent Info</ng-container>
            </lib-section-header>

            <lib-input-text
                [formControl]="addStudentForm.controls.Parent.controls.FirstName"
                [errorMessages]="firstNameError">
                <ng-container label i18n="@@SUFDesignBlockParentFirstName">
                    #Parent# First Name
                </ng-container>
            </lib-input-text>

            <lib-input-text
                [formControl]="addStudentForm.controls.Parent.controls.LastName"
                [errorMessages]="lastNameError">
                <ng-container label i18n="@@SUFDesignBlockParentLastName">
                    #Parent# Last Name
                </ng-container>
            </lib-input-text>

            <lib-input-text [formControl]="addStudentForm.controls.Parent.controls.Email"
                [errorMessages]="emailError">
                <ng-container label i18n="@@SUFDesignBlockEmail">
                    Email
                </ng-container>
            </lib-input-text>

            <!-- ADDITIONAL FIELDS -->
                    <lib-input-text
                        [formControl]="addStudentForm.controls.Parent.controls.MobilePhone"
                        [errorMessages]="phoneError"
                        inputFilter="[0-9-\(\)\+]"
                        [layout]="FormFieldLayout.ExclusiveHalf">
                        <ng-container label i18n="@@SUFDesignBlockMobilePhone">
                            Phone
                        </ng-container>
                    </lib-input-text>

        }

        @if (data.AdditionalFields?.Address !== FieldMode.NotPresent && signupStudentMode !== SignupStudentMode.AdditionalStudent) {
            <lib-input-text-area
                [formControl]="addStudentForm.controls.Address"
                [errorMessages]="addressError">
                <ng-container label i18n="@@SUFDesignBlockAddress">
                    Address
                </ng-container>
            </lib-input-text-area>
        }

        @if (data.AdditionalFields?.Referrer !== FieldMode.NotPresent && signupStudentMode !== SignupStudentMode.AdditionalStudent) {
                <lib-input-text
                    [formControl]="addStudentForm.controls.Referrer">
                    <ng-container label i18n="@@SUFDesignBlockRefferer">
                        How did you hear about us?
                    </ng-container>
                </lib-input-text>
        }

        <!-- Once per form fields -->
        @if (hasFormCustomFields) {
            <div class="sb-form-field-full">
                <lib-signup-form-custom-fields
                    #formCustomFields
                    [kind]="FormAffinity.Form"
                    [fields]="data.CustomFields"
                    [form]="addStudentForm"
                    [isAdditionalStudent]="signupStudentMode === SignupStudentMode.AdditionalStudent"
                    [form]="addStudentForm"
                    [isViewOnly]="isViewOnly">
                </lib-signup-form-custom-fields>
            </div>
        }

</form>

<mat-divider></mat-divider>

<lib-submission-bar
    [kind]="submissionBarKind">
    <lib-button
    [role]="ButtonRole.Primary"
        [loading]="!isViewOnly && addStudentForm.disabled"
        [isViewOnly]="isViewOnly"
        [size]="ButtonSize.Large"
        (clicked)="SignupClicked()">
        <ng-container label>
            <!-- <ng-container i18n="@@CommonSignupButton" *ngIf="(isBookingWidget && (stepper.currentStep + 1 === stepper.steps.length)) || (!isBookingWidget && !(stepper.steps.length > 1 && signupStudentMode === SignupStudentMode.AdditionalStudent))">Sign Up</ng-container> -->
            <!-- <ng-container i18n="@@CommonNextButton" *ngIf="(isBookingWidget && (stepper.currentStep + 1 !== stepper.steps.length)) || (!isBookingWidget && stepper.steps.length > 1 && signupStudentMode === SignupStudentMode.AdditionalStudent)">Next</ng-container> -->
            <!-- <ng-container i18n="@@CommonSignupButton" *ngIf="(isBookingWidget && !hasPaymentType) || (!isBookingWidget && !(hasPaymentType && signupStudentMode === SignupStudentMode.AdditionalStudent))">Sign Up</ng-container> -->
            <!-- <ng-container i18n="@@CommonNextButton" *ngIf="(isBookingWidget && hasPaymentType) || (!isBookingWidget && hasPaymentType && signupStudentMode === SignupStudentMode.AdditionalStudent)">Next</ng-container> -->

            @if(currentStepIndex < totalStepCounts && currentStepIndex === 1) {
                @if(signupStudentMode !== SignupStudentMode.AdditionalStudent) {
                    <ng-container i18n="@@CommonContinueButton">Continue</ng-container>
                } @else {
                    <ng-container i18n="@@CommonNextButton">Next</ng-container>
                }
            } @else {
                <ng-container i18n="@@CommonSignupButton" >Sign Up</ng-container>
            }
        </ng-container>
    </lib-button>

    @if ((!isBookingWidget && signupStudentMode === SignupStudentMode.AdditionalStudent) || isBookingWidget) {
        <lib-button
            [role]="ButtonRole.Secondary"
            [kind]="ButtonKind.NeutralSecondary"
            [disabled]="addStudentForm.disabled"
            [isViewOnly]="isViewOnly"
            [size]="ButtonSize.Large"
            (clicked)="StudentSecondaryActionClicked()">
            <ng-container label>
                @if ((!isBookingWidget && signupStudentMode === SignupStudentMode.AdditionalStudent)) {
                <ng-container i18n="@@CommonCancelButton">Cancel</ng-container>
                }
                @if (isBookingWidget) {
                <ng-container i18n="@@CommonPreviousButton">Previous</ng-container>
                }
            </ng-container>
        </lib-button>
    }

    <ng-template #customAction>
        <p class="typography-label-large" i18n="@@CommonCurrentStepOfStepsLabel">{{currentStepIndex}} of {{totalStepCounts}}</p>
    </ng-template>
</lib-submission-bar>

<div [ngClass]="{'padding-x-32': !isMobile , 'padding-x-16': isMobile}">
    <ng-content select="[captchaText]"></ng-content>
</div>